import React, { useMemo, useState, useEffect } from 'react';
import { State } from 'state';
import { useSelector, useDispatch } from 'react-redux';
import fetchMessageAuditLog from '../../../../state/actions/fetch-message-audit-log';
import { Spinner, UserAvatar } from '../../../components';
import { Folder } from '../../../../state/types';
import styles from './index.module.scss';

export interface Props {
  messageId: string;
  openAuditLogModal: () => void;
  folder: Folder;
}

const ManualTagTooltip: React.FC<Props> = ({ messageId, openAuditLogModal, folder }) => {
  const [isSpinner, setIsSpinner] = useState<boolean>(true);
  const dispatch = useDispatch();
  const { tooltipInfo, users } = useSelector((state: State) => {
    return {
      tooltipInfo: state.moderation.audit.auditLogs[messageId]?.tooltip,
      users: state.moderation.users.users
    };
  });
  const user = users[tooltipInfo?.userId];
  const userDisplayName = user?.getDisplayName();
  const isPendingFolder = folder === Folder.PENDING;

  useEffect(() => {
    if (!tooltipInfo) {
      dispatch(fetchMessageAuditLog({ messageId, limit: 1, isOnlyManual: true }));
    }
  }, []);

  useEffect(() => {
    if (tooltipInfo) {
      setIsSpinner(false);
    }
  }, [tooltipInfo]);

  return (
    <div data-testid={'manual-tag-tooltip'} className={styles.container}>
      {isSpinner ? (
        <Spinner size={'small'} />
      ) : (
        <>
          {Object.keys(tooltipInfo).length > 0 ? (
            <>
              <div className={styles.text}>
                <span>{`${isPendingFolder ? 'Previously moved' : 'Moved'} to ${
                  tooltipInfo.currentState
                } by`}</span>
                <UserAvatar className={styles.auditLogAvatar} user={user} avatarSize={'small'} />
                <span>{`${userDisplayName}`}</span>
              </div>
              <div className={styles.avatarContainer}>
                <a className={styles.viewLogButton} onClick={openAuditLogModal}>
                  View Log
                </a>
              </div>
            </>
          ) : (
            <span>{`${
              isPendingFolder ? 'Previously moved' : 'Moved'
            } to ${folder} by Moderator`}</span>
          )}
        </>
      )}
    </div>
  );
};

export default ManualTagTooltip;
